import React from 'react';
import { Outlet } from 'react-router-dom';
import { ENV } from 'config/env';
import './AuthLayout.css';

/** Centered shell for public auth pages (login, etc.). */
const AuthLayout = () => (
  <div className="kvo-auth-layout">
    <div className="kvo-auth-layout__panel">
      <div className="kvo-auth-layout__brand">
        <span className="kvo-auth-layout__logo">JY</span>
        <span className="kvo-auth-layout__brand-name">{ENV.APP_NAME}</span>
      </div>
      <h2 className="kvo-auth-layout__tagline">Newspaper monitoring, made effortless.</h2>
      <p className="kvo-auth-layout__sub">
        Track regional newspapers, match keywords, and review captured articles from one console.
      </p>
    </div>
    <div className="kvo-auth-layout__content">
      <div className="kvo-auth-layout__form">
        <Outlet />
      </div>
    </div>
  </div>
);

export default AuthLayout;
